<template>
    <div>
        <Nav></Nav>
        <PageHeader :linkto="'/login'" :linkttitle="'返回'" title=""></PageHeader>

        <b-container class="bg-white p-3 p-md-5 mt-5 mt-sm-2 shadow-sm rounded ">

            <b-form style="max-width: 450px" class="mx-auto">
                <h3 class="text-center mb-5">註冊會員</h3>
                <TipsAlert :tipswords="masterTips.tipswords"
                           :status="masterTips.status"
                           :videostatus="masterTips.videostatus"
                           :videosrc="masterTips.videosrc">

                </TipsAlert>
                <b-form-group label-for="phone" description="">
                    <label>姓名<span class="text-danger">* 請輸入真實姓名</span></label>
                    <b-input-group class="mb-2">
                        <b-form-input v-model="formData.firstname"
                                      type="text"
                                      required
                                      maxlength="2"
                                      @change="checkvalue('name')"
                                      placeholder="輸入姓氏"></b-form-input>
                        <b-form-input v-model="formData.lastname"
                                      type="text"
                                      required
                                      maxlength="2"
                                      @change="checkvalue('name')"
                                      placeholder="輸入姓名"></b-form-input>

                    </b-input-group>
                    <b-form-invalid-feedback :state="formData.namecheck">
                        {{ formData.namemsg }}
                    </b-form-invalid-feedback>
                </b-form-group>
                <hr>

                <b-form-group>
                    <label>性別<span class="text-danger">* </span></label>
                    <b-form-radio-group
                            v-model="selected"
                            :options="options"
                            name="radio-inline"
                            @input="checkvalue('male')"
                    ></b-form-radio-group>
                    <b-form-invalid-feedback :state="formData.malecheck">
                        {{ formData.malemsg }}
                    </b-form-invalid-feedback>
                </b-form-group>


                        <b-form-group

                                label-for="phone"
                                description=""
                        >
                            <label>手機號碼<span class="text-danger">*</span></label>
                            <b-input-group class="mb-2">
                            <b-form-select v-model="globZoneSelect" :options="globZone"  @change="checkvalue('phonezone')"></b-form-select>
                            <b-form-input
                                    id="phone"
                                    v-model="formData.username"
                                    type="text"
                                    required
                                    :maxlength="phoneMaxLen"
                                    @change="checkvalue('username')"
                                    placeholder="輸入手機號碼"
                                    autocomplete
                            ></b-form-input>
                            </b-input-group>
                            <b-form-invalid-feedback :state="formData.usernamecheck">
                                {{ formData.usernamemsg }}
                            </b-form-invalid-feedback>
                        </b-form-group>

                        <b-form-group

                                label-for="phone"
                                description=""
                        >
                            <label>驗證碼<span class="text-danger">*</span></label>
                            <b-input-group>
                                <b-button v-if="smsbtn" variant="success" @click="sendSMS" ><b-spinner small type="grow" v-if="smsloading"></b-spinner>取得驗證碼</b-button>

                            <b-form-input
                                    v-else
                                    v-model="formData.verifcode"
                                    type="text"
                                    required
                                    maxlength="4"
                                    @change="checkvalue('verifcode')"
                                    placeholder="輸入簡訊驗證碼"
                            ></b-form-input>
                                <b-input-group-append>
                                    <b-button v-if="!smsbtn" variant="success" :disabled="!smsbtn"> {{countDown}}'s </b-button>
                                </b-input-group-append>

                            </b-input-group>
                            <b-form-invalid-feedback :state="formData.verifcodecheck">
                                {{ formData.verifcodemsg }}
                            </b-form-invalid-feedback>

                        </b-form-group>

                <b-alert v-if="!smsbtn" variant="success" show>已寄送簡訊驗證碼 {{countDown}}'s</b-alert>



                <b-form-group

                        description=""
                >
                    <label>密碼<span class="text-danger">*</span></label>
                    <b-form-input

                            name="password"
                            v-model="formData.password"
                            type="password"
                            maxlength="12"
                            required
                            @change="checkvalue('password')"
                            placeholder="輸入密碼"
                            autocomplete="password"
                    ></b-form-input>
                    <b-form-invalid-feedback :state="formData.passwordcheck">
                        {{ formData.passwordmsg }}
                    </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group

                        label-for="email"
                        description=""
                >
                    <label>信箱</label>
                    <b-form-input
                            id="email"
                            v-model="formData.email"
                            type="text"
                            required
                            maxlength="50"
                            @change="checkvalue('email')"
                            placeholder="輸入信箱"
                    ></b-form-input>
                    <b-form-invalid-feedback :state="formData.emailcheck">
                        {{ formData.emailmsg }}
                    </b-form-invalid-feedback>
                </b-form-group>
                <hr>
                <h6 v-if="false" class="text-primary">擁有邀請優惠碼？
                    <b-button pill v-bind:variant="(Promotion.yes?'primary mr-2':'outline-primary mr-2')" size="sm"
                              @click="Promotion.yes=true;Promotion.no=false">我有
                    </b-button>
                    <b-button pill v-bind:variant="(Promotion.no?'primary mr-2':'outline-primary mr-2')" size="sm"
                              @click="Promotion.yes=false;Promotion.no=true">沒有
                    </b-button>
                </h6>
                <b-card
                        v-if="Promotion.yes"
                        border-variant="primary"
                        header-bg-variant="primary"
                        header-text-variant="white"
                        align="center"

                >
                    <b-card-text>填寫您的推薦邀請碼，您與你的朋友雙方即可獲得免費點數喔！</b-card-text>
                    <b-overlay :show="Promotion.spinner" rounded="lg" opacity="0.6" spinner-small
                               spinner-variant="primary">
                        <b-form-input
                                id="email"
                                v-model="formData.PromotionCode"
                                type="text"
                                required
                                maxlength="20"
                                placeholder="輸入邀請優惠碼"
                                @blur="checkpromotioncode"
                                :state="Promotion.codeisgood"
                        ></b-form-input>
                        <b-form-invalid-feedback :state="Promotion.codeisgood">
                           找不到邀請碼
                        </b-form-invalid-feedback>
                    </b-overlay>
                </b-card>
                <b-card
                        v-if="Promotion.no"
                        border-variant="primary"
                        header-bg-variant="primary"
                        header-text-variant="white"
                        align="center"

                >
                    <b-card-text>註冊成功後，分享您的『邀請碼』給您的朋友成功註冊雙方即可獲得免費點數！</b-card-text>
                </b-card>
                <b-overlay
                        :show="registerloading"
                        rounded
                        opacity="0.6"
                        spinner-small
                        spinner-variant="primary"
                        class=" mt-3"

                >
                    <b-button class="mt-3" variant="primary ActionBtnBg" pill block @click="Register">送出註冊</b-button>
                </b-overlay>
                <p class="my-4 text-center">已經註冊帳號？
                    <b-link href="#foo" to="/Login">立即登入</b-link>
                </p>

            </b-form>
        </b-container>
        <p class="mt-3 mb-5 text-center text-muted">註冊並使用賬號表明您已閱讀和同意
            <a class="text-muted" target="_blank" href="https://www.name-q.com/privacy">《用戶協議》</a>
        </p>

    </div>


</template>
<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import PageHeader from '@/components/PageHeader.vue'
import TipsAlert from '@/components/TipsAlert.vue'

import { toastsModel,isch } from '@/service/commuse'

export default {
  name: 'login',
  components: {Nav, PageHeader, TipsAlert},
  data () {
    return {
      phoneMaxLen:10,
      globZoneSelect:'886',
      globZone:[
        { value: '886', text: '台灣(886)' },
        { value: '852', text: '香港(852)' },
        { value: '65', text: '新加坡(65)' },
        { value: '60', text: '馬來西亞(60)' },
      ],
      masterTips:{
        status:true,
        videostatus:false,
        videosrc:'',
        tipswords:'為了測算與比對的精準，姓和名請務必要認真填寫您的真實姓名，打錯字就不準了唷，請按下註冊鍵時再三檢查資料是否正確。',
      },
      formData: {
        verifcode:'',
        verifcodecheck:null,
        verifcodemsg:'',
        username: '',
        usernamecheck: null,
        usernamemsg: '',
        password: '',
        passwordcheck: null,
        passwordmsg: '',
        firstname: '',
        lastname: '',
        namecheck: null,
        namemsg: '',
        email: '',
        emailcheck: null,
        emailmsg: '',
        male: 0,
        malecheck: null,
        malemsg: '',
        PromotionCode: '',
        installLocation: ''
      },
      selected: '',
      options: [
        {text: '男', value: '1'},
        {text: '女', value: '0'}
      ],
      Promotion: {
        yes: false,
        no: false,
        codeisgood: null,
        spinner: false,
        message:''
      },
      registerloading: false,
      smsloading:false,
      countDown: 1800, //倒计时
      smsbtn:true
    }
  },
  computed: {},
  mounted(){
    // console.log(  this.$route.params.id)
  },
  methods: {

    checkvalue (way) {
      switch (way) {
        case 'name':


          if (this.formData.firstname.length === 0 || this.formData.lastname.length === 0) {
            this.formData.namemsg = '請輸入真實姓名'
            this.formData.namecheck = false

          }else{
            this.formData.namemsg = ''
            if (!isch(this.formData.firstname) ) {
              this.formData.namemsg = '請填寫中文姓名名字'
              this.formData.namecheck = false
            }else{
              this.formData.namemsg = ''
              this.formData.namecheck = true
            }
          }
          break
        case 'verifcode':

          let isNum = /^\d+$/


          if(!this.smsbtn){
            if (this.formData.verifcode.length == 0 || this.formData.verifcode.length < 4) {
              this.formData.verifcodemsg = '請輸入驗證碼'
              this.formData.verifcodecheck = false
            }

            if (this.formData.verifcode.length == 4 ) {
              this.formData.verifcodemsg = ''
              this.formData.verifcodecheck = true
            }
            if (!isNum.test(this.formData.verifcode)) {
              this.formData.verifcodemsg = '請輸入數字驗證碼'
              this.formData.verifcodecheck = false
            }
          }else if( this.formData.usernamecheck){
            this.formData.verifcodemsg = '點擊取得認證簡訊'
            this.formData.verifcodecheck = false
          }

          break
        case 'phonezone':
          switch (this.globZoneSelect){
            case '886':
              this.phoneMaxLen = 10
              break
            case '852':
              this.phoneMaxLen = 8
              break
            case '65':
              this.phoneMaxLen = 8
              break
            case '60':
              this.phoneMaxLen = 9
              break

          }
          this.formData.username = ''
          break
        case 'username':
          if (this.formData.username.length == 0 || this.formData.username.length < this.phoneMaxLen ) {
            this.formData.usernamemsg = '請填寫行動電話號碼'
            this.formData.usernamecheck = false
          }
          let isPhone = ''
          switch (this.globZoneSelect){
            case '886':

              isPhone = /^09\d{8}$/
              break
            case '852':

              isPhone = /^\d{8}$/
              break
            case '65':
              isPhone = /^\d{8}$/
              break
            case '60':
              isPhone =  /^\d{9}$/
              break

          }

          if (!isPhone.test(this.formData.username)) {
            this.formData.usernamemsg = '請填寫正確行動電話號碼'+this.formData.username
            this.formData.usernamecheck = false
          }
          else {
            this.formData.usernamemsg = ''
            this.formData.usernamecheck = true
          }
          break
        case 'password':
          let isPwd = /^([a-zA-Z]+\d+|\d+[a-zA-Z]+)[a-zA-Z0-9]*$/
          let Password = this.formData.password
          if (Password.length < 6 || Password.length > 12 || !isPwd.test(Password)) {
            this.formData.passwordcheck = false
            this.formData.passwordmsg = '登錄密碼必須6-12位，包含數字+字母組合!'
          } else {
            this.formData.passwordcheck = true
          }
          break
        case 'male':

          if (this.selected === '') {
            this.formData.malecheck = false
            this.formData.malemsg = '請選擇性別'
          } else {
            this.formData.male = this.selected
            this.formData.malecheck = true
          }
          break
        case 'email':
          let emailRule = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/
          if (!emailRule.test(this.formData.email)) {
            this.formData.emailmsg = '請輸入您的信箱'
            this.formData.emailcheck = false
          } else {
            this.formData.emailcheck = true
          }
          break
        case 'namefinalcheck':

          if (this.selected === '') {
            this.formData.malecheck = false
            this.formData.malemsg = '請選擇性別'
          } else {
            this.formData.malecheck = true
          }
          break
      }

    },
    Register () {
      this.checkvalue('name')
      this.checkvalue('username')
      this.checkvalue('password')
      this.checkvalue('male')

      this.checkvalue('verifcode')


      if(this.formData.email.length > 0){
        this.checkvalue('email')
      }

      if (
        this.formData.namecheck == true &&
        this.formData.passwordcheck == true &&
        this.formData.usernamecheck == true &&
        this.formData.malecheck == true &&
        this.formData.verifcodecheck == true
      ) {
        this.registerloading = true
        this.$store.dispatch('actionRegister', {
          username: this.formData.username,
          password: this.formData.password,
          phoneCode:this.globZoneSelect,
          phone: this.formData.username,
          mail: this.formData.email,
          firstname: this.formData.firstname,
          lastname: this.formData.lastname,
          nametype: this.formData.firstname.length == 2 ? 1 : 0,
          male: this.formData.male,
          PromotionCode: this.formData.PromotionCode,
          SalesInviteCode:this.$route.params.id=='default'?'':this.$route.params.id,
          installLocation: 'TW',
          VerifCode:this.formData.verifcode
        }).then((res) => {
          this.$store.dispatch('actionGetMemberInfo', {})
            .then((res) => {
              this.$router.push('/home')
              this.registerloading = false
            })
            .catch((res) => {
              this.registerloading = false
            })

        }).catch((res) => {
          toastsModel(this,res.message)
          this.registerloading = false
        })
      }

    },
    checkpromotioncode () {
      this.Promotion.codeisgood = null
      if(this.formData.PromotionCode.length > 0){

        this.Promotion.spinner = true
        this.$store.dispatch('actionGetShareCodeCheck', {
          promotioncode:this.formData.PromotionCode
        })
          .then((res) => {
            this.Promotion.codeisgood = true
            this.Promotion.spinner = false
          })
          .catch((res) => {
            this.Promotion.codeisgood = false
            this.Promotion.spinner = false
          })

      }

    },
    sendSMS(){

      this.checkvalue('username')
      if (this.formData.usernamecheck == true
      ) {

        this.smsloading=true
        this.$store.dispatch('actionSendVerifCode', {
          phone:this.formData.username,
          phoneCode:this.globZoneSelect
        })
          .then((res) => {

            this.smsbtn = false
            this.count(res.data.exp);
            this.formData.verifcodemsg = ''
            this.formData.verifcodecheck = true
            this.smsloading = false
          })
          .catch((res) => {

            this.errsend("錯誤訊息-認證簡訊",res.message)
            // this.formData.verifcodemsg = res.message
            this.formData.verifcodecheck = false
            this.smsloading = false
          })
      }
    },
    count(exp) {
      const dateTime = Date.now();
      const timestamp = Math.floor(dateTime);
      this.countDown = parseInt((exp*1000-timestamp)/1000);

      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.countDown--;
        if (this.countDown == 0) {

          clearInterval(this.timer);

          this.smsbtn = true
        }
      }, 1000);
    },
    errsend(title,err){
      var ua = navigator.userAgent;
      this.$store.dispatch('actionErrSend', {
        device:ua,
        errorinfo:err,
        title:title

      })
        .then((res) => {

        })
        .catch((res) => {

        })


    }
  }
}
</script>
